import React from 'react';
import classnames from 'classnames';

const Title = ({ disabled, disabledText, text, className, style }) => {
  return (
    <p 
      className={classnames("stepDescriptionText", className)}
      style={style}
    >
       {disabled ? disabledText : text}
    </p>
  )
}

Title.defaultProps = {
  className: '',
  style: {}
}

export default Title;